import Collapsible from "app/components/Collapsible/Collapsible";
import { IconSports } from "app/components/Icon/Icon";
import { Legs } from "app/types/reportType";
import { useState } from "react";
import { BetBuilderCollapsibleHeader } from "./BetBuilderCollapsibleHeader";
import BetBuilderItemDetails from "./BetBuilderItemDetails";

type Props = {
  contentType: string;
  legs: Legs | undefined;
  multiplierName: string | undefined;
  submittedType: string;
  translatedBetType: string;
  betType: string;
  eventName: string;
};

// Shows a header for each bet builder
// - Icon
// - Bet Builder text
// - Event name
// Collapsible content is the bet builder items

const BetBuilderReport: React.FC<Props> = props => {
  const {
    contentType,
    legs,
    multiplierName,
    submittedType,
    translatedBetType,
    eventName,
    betType,
  } = props;
  const [collapsibleOpen, setCollapsibleOpen] = useState(false);

  const toggleCollapsible = () => {
    setCollapsibleOpen(!collapsibleOpen);
  };

  // all legs have same sport
  const multipleSportName = legs?.[0]?.sportName;

  return (
    <>
      <div className="report__header bb">
        <div className={"report__header__icon"}>
          <IconSports name={multipleSportName} />
        </div>
        <div className="report__header__title">
          <div className="report__header__title report__header__title--open-bets">
            <div className="report__header__title__primary">
              <span>{translatedBetType}</span>
            </div>
            <div className="report__header__title__secondary">
              <span>{eventName}</span>
            </div>
          </div>
        </div>
      </div>

      <Collapsible
        header={
          <BetBuilderCollapsibleHeader
            multiplierName={multiplierName}
            collapsibleOpen={collapsibleOpen}
          />
        }
        content={
          <div>
            {" "}
            {legs &&
              legs.map((leg, index) => {
                return (
                  <div
                    className={"report__header__multiples__item"}
                    key={index}
                  >
                    <BetBuilderItemDetails
                      marketName={leg.marketName}
                      runnerName={leg.runnerName}
                      betType={betType}
                      index={index}
                      numberOfItems={legs.length}
                    />
                  </div>
                );
              })}
          </div>
        }
        isActive={collapsibleOpen}
        onToggle={toggleCollapsible}
        withArrows={false}
      />
    </>
  );
};

export default BetBuilderReport;
